import type { IAdTag } from "@/src/common/AdTag/AdTag";
import type { IImageLoader } from "@Components/ImageLoader";

export const preventScrollY = (event: TouchEvent) => event.preventDefault();

export const FlyerDisplayPosition = {
    Center: 0,
    Left: 1,
    Right: 2,
};

export type IFlyerCatalogueImage = {
    image: IImageLoader;
    isBanner: boolean;
    bannerId?: string;
    bannerUrl?: string;
    pageNumber: number;
    adContent?: IAdTag;
    displayPosition: number;
    carouselPosition: number;
};
